import React from "react";
import "../../styles/App.css";
import {EmergencyContact} from "../../models/emergencyContact";
import {useTranslation} from "react-i18next";
import {MdLock, MdLockOpen} from "react-icons/md";

type EmergencyContactCardProps = {
    emergencyContact: EmergencyContact
    onEdit: (id: number) => void;
    onDelete: (id: number) => void;
};

function EmergencyContactCard({emergencyContact, onEdit, onDelete}: EmergencyContactCardProps) {
    const {t} = useTranslation();

    return (
        <div className="contact-card">
            <div className="contact-content">
                <div className="contact-header">
                    <strong>{emergencyContact.lastName}, {emergencyContact.firstName}</strong>

                    <div className="contact-lock-icon">
                        {emergencyContact.shareData ? <MdLockOpen/> : <MdLock/>}
                    </div>
                </div>
                <div className="contact-details">
                    <p>{emergencyContact.details}</p>
                </div>
            </div>

            <div className="contact-actions">
                <button
                    type="button"
                    className="form-button-secondary contact-button"
                    onClick={() => onEdit(emergencyContact.id)}
                >
                    {t("common.button.edit")}
                </button>
                <button
                    type="button"
                    className="form-button-secondary contact-button"
                    onClick={() => onDelete(emergencyContact.id)}
                >
                    {t("common.button.delete")}
                </button>
            </div>
        </div>
    );
}

export default EmergencyContactCard;